import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"22\" cy=\"22\" r=\"22\" fill=\"var(--status-svg-color)\"></circle><g stroke=\"#FFF\" stroke-width=\"2\" transform=\"translate(11 13)\"><path d=\"M16 18v-2a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v2\"></path><circle cx=\"8\" cy=\"4\" r=\"4\"></circle><path d=\"M22 18v-2a4 4 0 0 0-3-3.87M15 .13a4 4 0 0 1 0 7.75\"></path></g></g>", 1)
  ]))]))
}
export default { render: render }